/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import {
  getConvertedUnit,
  getConvertedValues
} from '../../../../shared/Utils/EnergyUsagesViewDetailsUtils';
import { getPercentageColor } from '../../../PortfolioEnergyUsageViewDetails/PremiumSubscription/AllUtilitiesDetails/BottomSection/TableColumnRenderUtils';
import { ConversionType, getConvertedValue } from '../../../../../main';
interface IEnergyBreakDownChange {
  unit: string;
  value: number;
  percentageEmissionsSaving: number;
  energyMeasurementUnit: string;
  sourceType?: string;
}
const EnergyBreakDownChangeComponent = (props: IEnergyBreakDownChange) => {
  const {
    value,
    unit,
    percentageEmissionsSaving,
    energyMeasurementUnit
  } = props;

  return value && value !== null ? (
    <span className="score-category-meterdata-meter">
      <span
        className="savings-badge"
        style={{ color: getPercentageColor(percentageEmissionsSaving) }}
      >
        {
          getConvertedValue(
            props.sourceType ? props.sourceType : ConversionType?.ELECTRICITY,
            energyMeasurementUnit,
            Math.abs(Number(value)),
            unit
          ).Value
        }
        {' ' +
          getConvertedUnit(value, unit) +
          ' ' +
          '(' +
          getConvertedValues(percentageEmissionsSaving) +
          '%' +
          ')'}
      </span>
    </span>
  ) : (
    <span className="score-category-meterdata-meter">--</span>
  );
};

export default EnergyBreakDownChangeComponent;
